// Libraries
import {
  TemplateRef,
  Injectable
} from '@angular/core';

// Interfaces
import { ConfirmationPopoverOptions } from './confirmation-popover-options.provider';

@Injectable()
export abstract class ConfirmationPopoverWindowOptions extends ConfirmationPopoverOptions {
  public customTemplate: TemplateRef<any>;

  public abstract onConfirm(): void;
  public abstract onCancel(): void;
  public abstract onAfterViewInit(): void;
}
